import React from "react";
import { loaderContext } from "../providers/LoaderProvider";

function useLoader() {
  const loader = React.useContext(loaderContext);

  return loader;
}
export default useLoader;
